import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FeatureCards from "./sections/FeatureCards";
import About from "./sections/About";
import Commitment from "./sections/Commitment";
import LegalServices from "./sections/LegalServices";
import CallToActionBanner from "./sections/CallToActionBanner";
import Team from "./sections/Team";
import WorkSystem from "./sections/WorkSystem";
import Testimonials from "./sections/Testimonials";
import Statistics from "./sections/Statistics";
import FAQ from "./sections/FAQ";
import Contact from "./sections/Contact";
import QuickConsultCard from "./sections/QuickConsultCard";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FeatureCards />
      <About />
      <Commitment />
      <LegalServices />
      <CallToActionBanner />
      <Team />
      <WorkSystem />
      <Testimonials />
      <Statistics />
      <FAQ />
      <Contact />
      <QuickConsultCard />
      <Footer />
    </div>;
}